export const signupSteps = [
  { url: '/sign-up', targetColumn: 'email' },
  { url: '/password', targetColumn: 'password' },
  { url: '/business-name', targetColumn: 'handle' },
  { url: '/business-type', targetColumn: 'business_type' },
  { url: '/referral', targetColumn: 'referred_by' },
  { url: '/area-code', targetColumn: 'preferred_provision_area_code' }
]

export const signupStepUrls = signupSteps.map(step => step.url)

// The step after the furthest answered one, clamped to the last step. Not
// "first unanswered": the optional referral step may hold no answer while
// later steps do, and first-unanswered would drag the journey backwards.
export const signupStepAfter = answeredColumns => {
  const lastAnsweredIndex = signupSteps.reduce(
    (last, step, index) => (answeredColumns.includes(step.targetColumn) ? index : last),
    -1
  )
  return signupSteps[Math.min(lastAnsweredIndex + 1, signupSteps.length - 1)]
}
